import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box } from "@mui/material";

export default function Clients() {
  const clientImages = [
    "jmi.png",
    "nipro.png",
    "unix.png",
    "maruf.png",
    "global.png",
    "oksmart.jpeg",
  ];

  const settings = {
    autoplay: true,
    autoplaySpeed: 1500,
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <Box>
      <div className="clients p-5" id="clients">
        <h5 className="text-center fw-bold f-upper pb-5">Our Clients</h5>
        <Slider {...settings}>
          {clientImages.map((img, index) => (
            <div
              className="clientsSlide d-flex justify-content-center align-items-center"
              key={index}
              style={{ padding: "10px" }}
            >
              <img
                src={require(`../assets/images/clients/${img}`)}
                alt={`client-${index}`}
                style={{
                  maxWidth: "100%", // image won’t overflow
                  maxHeight: "80px", // keeps uniform height
                  objectFit: "contain", // maintains aspect ratio
                }}
              />
            </div>
          ))}
        </Slider>
      </div>
    </Box>
  );
}
